//carousel
(function ($, Drupal) {
  Drupal.behaviors.swiperNewsCarousel = {
    attach: function (context, settings) {
      const swiper = new Swiper('.swiper-news-carousel', {
        // Optional parameters
        rewind: true,
        // loop: true,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        // centerInsufficientSlides: true,

        // default
        // width: 265,
        slidesPerView: 'auto',
        spaceBetween: 8,
        grabCursor: true,

        // If we need pagination
        pagination: {
          enabled: true,
          type: 'bullets',
          el: '.swiper-pagination',
          clickable: true,
        },

        // Navigation arrows
        navigation: {
          enabled: true,
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },

        // Breakpoints
        breakpoints: {
          1: {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
              type: 'bullets'
            },
            grabCursor: true,
          },
          //~265W
          390: {
            width: 358,
            slidesPerView: '1.33',
            spaceBetween: 16,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
            grabCursor: true,
          },
          //300W
          744: {
            width: 624,
            slidesPerView: 2,
            spaceBetween: 24,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
            grabCursor: true,
          },
          //432W
          1024: {
            width: 904,
            slidesPerView: 2,
            spaceBetween: 40,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
            grabCursor: true,
          },
          //360W
          1440: {
            width: 1160,
            slidesPerView: 3,
            spaceBetween: 40,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
            grabCursor: true,
          },
          //504W
          1920: {
            width: 1640,
            slidesPerView: 3,
            spaceBetween: 64,
            navigation: {
              enabled: true,
            },
            pagination: {
              enabled: true,
            },
            grabCursor: true,
          },
        },
      });

    }
  }
})(jQuery, Drupal);
